import React, { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Scroll behaviour on route change:
 * - Language switch on the same page (only /fr ↔ /en changed) → keep scroll position.
 * - Route has a hash (e.g. /fr#expertise) → scroll to that element.
 * - Otherwise → scroll to top.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    const prev = window.__elqPrev || { pathname: null, hash: "" };
    window.__elqPrev = { pathname, hash };

    if (navType === "POP") return;

    const stripLang = (p) => p.replace(/^\/(fr|en)(?=\/|$)/, "") || "/";
    const langOf = (p) => {
      const m = /^\/(fr|en)(?=\/|$)/.exec(p || "");
      return m ? m[1] : null;
    };

    const isLangSwitch =
      prev.pathname !== null &&
      prev.hash === hash &&
      stripLang(prev.pathname) === stripLang(pathname) &&
      langOf(prev.pathname) !== langOf(pathname);

    if (isLangSwitch) return;

    if (hash) {
      const id = hash.replace("#", "");
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ block: "start" });
        else window.scrollTo(0, 0);
      });
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, hash, navType]);

  return null;
}
